import { render, staticRenderFns } from "./filterPopupItem.vue?vue&type=template&id=51fecc78&scoped=true&"
import script from "./filterPopupItem.vue?vue&type=script&lang=js&"
export * from "./filterPopupItem.vue?vue&type=script&lang=js&"
import style0 from "./filterPopupItem.vue?vue&type=style&index=0&id=51fecc78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fecc78",
  null
  
)

export default component.exports